import React, { useEffect, useState } from "react";
import { Line, Bar } from "react-chartjs-2";
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import { getAuth, onAuthStateChanged, updateEmail, updatePassword } from "firebase/auth";
import { auth, db } from "../FirebaseConfig";
//import "./Dashboard.css";
import "chart.js/auto";
import PayoutHistory from "./pay/PayoutHistory";
import { useNavigate } from "react-router-dom";
import LeadsTable from "./leads/LeadsTable";
import triteklogo from "./triteklogo.png";
import OrdersTableuser from "./OrdersTableuser";
import OrdersTable from "./OrdersTable";

const Dashboard = () => {
  const [user, setUser] = useState({});
  const [leads, setLeads] = useState([]);
  const [earnings, setEarnings] = useState(0);
  const [leadStats, setLeadStats] = useState({
    total: 0,
    pending: 0,
    completed: 0,
  });
  const [currentView, setCurrentView] = useState("dashboard"); // Manage views
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false); // Sidebar toggle
  const [referralId, setReferralId]=useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) { // Adjust breakpoint for mobile as needed
        setSidebarCollapsed(true);
      } else {
        setSidebarCollapsed(false);
      }
    };
  
    // Run on initial render
    handleResize();
  
    // Add resize event listener
    window.addEventListener("resize", handleResize);
  
    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const auth = getAuth();
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          const userRef = collection(db, "influencers");
          const userQuery = query(userRef, where("uid", "==", user.uid));
          const userSnapshot = await getDocs(userQuery);

          if (!userSnapshot.empty) {
            const currentUser = userSnapshot.docs[0].data();
            setUser(currentUser);
            setReferralId(currentUser.referralId)
            const leadsQuery = query(
              collection(db, "leads"),
              where("referralId", "==", currentUser.referralId)
            );
            const leadSnapshot = await getDocs(leadsQuery);
            const leadData = leadSnapshot.docs.map((doc) => doc.data());

            let totalEarnings = 0;
            let pendingLeads = 0;
            let completedLeads = 0;
            leadData.forEach((lead) => {
              if (lead.status === "new") totalEarnings += 1;
              if (lead.status === "converted") {
                totalEarnings += 2;
                completedLeads += 1;
              }
              if (lead.status === "pending") pendingLeads += 1;
            });

            setEarnings(totalEarnings);
            setLeadStats({
              total: leadData.length,
              pending: pendingLeads,
              completed: completedLeads,
            });
            setLeads(leadData);
          }
        }else{
          navigate('/')
        }
      });
    };

    fetchData();
  }, []);

  const [copied, setCopied] = useState(false);
  const referralLink = `${window.location.origin}/lead/${referralId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);

    // Reset "Copied" state after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const handleUpdateUser = async (updatedInfo) => {
    const auth = getAuth();
    const userRef = doc(db, "influencers", user.id); // Assume user has an "id" field
  
    try {
      // Update Firestore user info
      await updateDoc(userRef, updatedInfo);
  
      // Update Auth email or password if necessary
      if (updatedInfo.email) {
        await updateEmail(auth.currentUser, updatedInfo.email);
      }
      if (updatedInfo.password) {
        await updatePassword(auth.currentUser, updatedInfo.password);
      }
  
      setUser((prev) => ({ ...prev, ...updatedInfo })); // Update local user state
      alert("Account updated successfully!");
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Failed to update account. Please try again.");
    }
  };
  
  // Chart Data
  const lineData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Leads Per Month",
        data: leads.reduce((acc, lead) => {
          const month = new Date(lead.createdAt).getMonth();
          acc[month] = (acc[month] || 0) + 1;
          return acc;
        }, Array(12).fill(0)),
        borderColor: "#4285f4",
        borderWidth: 2,
        fill: false,
      },
    ],
  };

  const barData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Earnings Per Month",
        data: leads.reduce((acc, lead) => {
          const month = new Date(lead.createdAt).getMonth();
          if (lead.status === "new") acc[month] += 1;
          if (lead.status === "converted") acc[month] += 2;
          return acc;
        }, Array(12).fill(0)),
        backgroundColor: "#66bb6a",
      },
    ],
  };

  return (
    <div className={`dashboard-container ${sidebarCollapsed ? "collapsed" : ""}`}  style={{background:'#F6F6FB'}}>
      {/* Sidebar */}
   
      <div className={`sidebar ${!sidebarCollapsed ? "open" : "collapsed"}`}>
      <img
        src={triteklogo}
        width={150}
        style={{margin:'2rem'}}
        />
        <ul>
          <li
            className={currentView === "dashboard" ? "active" : ""}
            onClick={() => setCurrentView("dashboard")}
          >
            Dashboard
          </li>
          <li
            className={currentView === "settings" ? "active" : ""}
            onClick={() => setCurrentView("settings")}
          >
            Settings
          </li>
          <li
            className={currentView === "logout" ? "active" : ""}
            onClick={() =>{
                auth.signOut()
                navigate('/')
            }}
          >
            Logout
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="main-content">
      <button
          className="toggle-btn"
          onClick={() => setSidebarCollapsed((prev) => !prev)}
        >
          {sidebarCollapsed ? "☰" : "✖"}
        </button>
        {currentView === "dashboard" && (
          <OrdersTable/>
        )}
      {currentView === "settings" && (
  <>
    {/* Settings View */}
    <div className="settings">
      <h2>Account Settings</h2>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const updatedInfo = {
            name: e.target.name.value,
            email: e.target.email.value,
            password: e.target.password.value,
            bankInfo: e.target.bankInfo.value, // Add bank info
          };
          handleUpdateUser(updatedInfo);
        }}
      >
        <div>
          <label>Name:</label>
          <input
            type="text"
            name="name"
            defaultValue={user.name || ""}
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            defaultValue={user.email || ""}
          />
        </div>
        <div>
          <label>New Password:</label>
          <input type="password" name="password" />
        </div>
        <button type="submit">Update</button>
      </form>
    </div>
  </>
)}

      </div>
    </div>
  );
};

export default Dashboard;
